import { CommentService } from './../core/comment.service';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

import { LinkFileListService } from './services/link-file-list.service';
import { LinkConsumeComponent } from './link-consume/link-consume.component';
import { LinkFileListComponent } from './link-file-list/link-file-list.component';
import { LinkErrorComponent } from './link-error/link-error.component';
import { LinkConsumePasswordComponent } from './link-consume-password/link-consume-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { LinkConsumeRoutingModule } from './link-consume-routing.module';
import { FileModule } from '../file/file.module';
import { ComponentsModule } from '@material-library';
import { FileListModule } from '../file-list/file-list.module';
@NgModule({
    imports: [
        LinkConsumeRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SharedModule,
        FileModule,
        ComponentsModule,
        FileListModule
    ],
    providers: [LinkFileListService, CommentService, Title],
    declarations: [
        LinkConsumeComponent,
        LinkFileListComponent,
        LinkErrorComponent,
        LinkConsumePasswordComponent,
    ],
    entryComponents: [
        LinkConsumeComponent,
    ]
})
export class LinkConsumeModule {}
